import { CreateBillingAgreementActions } from "@paypal/react-paypal-js";
import { useCallback } from "react";
import { setPaypalError } from "../../../../../../contexts/payments-client-context/state";
import {
  usePaymentsClientContext,
  usePaymentsClientStateContext,
} from "../../../../../../contexts/payments-client-context";

export type UseCreateBillingAgreementType = {
  handleCreateBillingAgreement: (
    data: Record<string, unknown>,
    actions: CreateBillingAgreementActions
  ) => Promise<string>;
};

export const useCreateBillingAgreement = (): UseCreateBillingAgreementType => {
  const { dispatch } = usePaymentsClientContext();
  const merchantDisplayName = usePaymentsClientStateContext()?.state
    ?.clientSetup?.registration?.braintree?.merchantDisplayName;
  const handleCreateBillingAgreement = useCallback(
    async (
      _: Record<string, unknown>,
      actions: CreateBillingAgreementActions
    ): Promise<string> => {
      dispatch(
        setPaypalError({
          isError: false,
          message: "",
        })
      );

      return actions.braintree.createPayment({
        flow: "vault",
        ...(merchantDisplayName && { displayName: merchantDisplayName }),
      });
    },
    [dispatch, merchantDisplayName]
  );
  return { handleCreateBillingAgreement };
};
